export const ROLE_OPTIONS = [
  { label: 'CFO', value: 'CFO' },
  { label: 'Controller', value: 'CONTROLLER' },
  { label: 'Credit Manager', value: 'CREDIT_MANAGER' },
  { label: 'Finance Director', value: 'FINANCE_DIRECTOR' },
  { label: 'Treasurer', value: 'TREASURER' },
  { label: 'CEO', value: 'CEO' },
  { label: 'President', value: 'PRESIDENT' },
  { label: 'Owner/Founder', value: 'OWNER_FOUNDER' },
  { label: 'Accounting', value: 'ACCOUNTING' },
  { label: 'Bookkeeper', value: 'BOOKKEEPER' },
  { label: 'Accounts Receivable', value: 'ACCOUNTS_RECEIVABLE' },
  { label: 'Office Manager', value: 'OFFICE_MANAGER' },
  { label: 'Other', value: 'OTHER' },
] as const;

export const LEAD_SOURCE_OPTIONS = [
  { label: 'Left Organization Email', value: 'LEFT_ORG_EMAIL' },
  { label: 'Inbound Email', value: 'INBOUND_EMAIL' },
  { label: 'Inbound Call', value: 'INBOUND_CALL' },
  { label: 'Inbound Chat', value: 'INBOUND_CHAT' },
  { label: 'Inbound Print', value: 'INBOUND_PRINT' },
  { label: 'Outbound Call', value: 'OUTBOUND_CALL' },
  { label: 'Outbound Email', value: 'OUTBOUND_EMAIL' },
  { label: 'Buyer Referral', value: 'BUYER_REFERRAL' },
  { label: 'Cross Over User', value: 'CROSSOVER' },
  { label: 'Responded to the Extranet Form', value: 'EXTRANET_FORM' },
  { label: 'Got the Contact via SRM Research', value: 'SRM_RESEARCH' },
  { label: 'Responded to Print Campaign', value: 'PRINT_CAMPAIGN' },
  { label: 'Contact Not Right Email Response', value: 'CONTACT_NOT_RIGHT_EMAIL' },
  { label: 'Contact Not Right Form Response', value: 'CONTACT_NOT_RIGHT_LEVEL_FORM' },
  { label: 'Buyer Term Extension', value: 'BUYER_TERM_EXTENSION' },
  { label: 'Verified this Lead Agent Contact', value: 'VERIFIED_LEAD_AGENT' },
  { label: 'Directly Contacted Me', value: 'DIRECT' },
] as const;

export const C2FO_EMAIL_DOMAINS = ['@c2fo.com', '@wfcfund.com'] as const;

export const generateTemporaryPassword = (): string => {
  const currentYear = new Date().getFullYear();

  // Prefer a cryptographically secure random number generator when available.
  let randomNumber: number;
  const cryptoObj: Crypto | undefined =
    (typeof globalThis !== 'undefined' && globalThis.crypto) ||
    (typeof window !== 'undefined' && window.crypto) ||
    undefined;

  if (cryptoObj && typeof cryptoObj.getRandomValues === 'function') {
    const array = new Uint32Array(1);
    cryptoObj.getRandomValues(array);
    // Map uniformly to the range 10-99 (inclusive).
    randomNumber = (array[0] % 90) + 10;
  } else {
    // Fallback to Math.random() only if a secure RNG is not available.
    randomNumber = Math.floor(Math.random() * 90) + 10;
  }

  return `c2fo-${currentYear}-${randomNumber}`;
};
